import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavBarButton from "../buttons/NavBarButton";
import Column from "../layout/Column";
import Space from "../layout/Space";
import { useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { getOrgByRef } from "../models/OrgFunctions";
import Icon1 from "../icons/Icon";
import { id } from "date-fns/locale";
import { count } from "firebase/firestore";
import { name } from "dayjs/locale/fr";
import Collapsible from "../layout/Collapsible";
import {
  hasBasic,
  hasExpert,
  hasInfiltro,
  isOnlyBasic,
} from "./VisibilityHelpers";

function ParametersNavBar({
  actualpage,
  override_id = null,
  navigateWorkspace,
  userData,
  orgData,
  workspaceData = null,
}) {
  const { currentUser, loading } = useAuth();

  const handleFetchData = async () => {};

  useEffect(() => {
    if (userData) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [userData]); // Dependency array ensures this runs when currentUser changes

  if (loading || !currentUser || !userData) {
    return <div></div>; // Show loading state while checking auth or if currentUser is null
  }

  return (
    <div className="flex flex-col w-fit min-w-c200 h-full pointer-events-auto overflow-y-auto  pb-20 pl-3 pr-1 bg-white border-r-1 border-shadow_10">
      <Space y={25} />
      <div className="text-hx font-medium pl-2">Paramètres</div>
      <Space y={27} />

      {/* Navigation buttons */}
      {!override_id && (
        <Collapsible
          title={"Mon compte"}
          defaultOpen={
            location.pathname.includes("/account") ||
            location.pathname.includes("/parameters")
          }
        >
          <NavBarButton
            icon="user"
            isActualPage={
              location.pathname.includes("/account") ||
              location.pathname.includes("/parameters")
            }
            onClick={() => navigateWorkspace("/account", orgData)}
          >
            Compte
          </NavBarButton>
        </Collapsible>
      )}

      {(!orgData.restrictions?.settings_access || userData.org_admin) && (
        <>
          <Collapsible
            title={"Entreprise"}
            defaultOpen={
              location.pathname.includes("/facturation") ||
              location.pathname.includes("/invitemanager") ||
              location.pathname.includes("/reminders") ||
              location.pathname.includes("/email")
            }
          >
            <NavBarButton
              icon="organisation"
              isActualPage={location.pathname.includes("/organisation")}
              onClick={() => navigateWorkspace("/organisation", orgData)}
            >
              Entreprise
            </NavBarButton>

            <NavBarButton
              icon="workspace"
              visible={!override_id}
              isActualPage={location.pathname.includes("/masters")}
              onClick={() => navigateWorkspace("/masters", orgData)}
            >
              Espaces
            </NavBarButton>
            <NavBarButton
              icon="facturation"
              visible={!override_id}
              isActualPage={location.pathname.includes("/facturation")}
              onClick={() => navigateWorkspace("/facturation", orgData)}
            >
              Facturation
            </NavBarButton>
            <NavBarButton
              icon="invite"
              visible={orgData.facturation.plan !== "free"}
              isActualPage={location.pathname.includes("/invitemanager")}
              onClick={() => navigateWorkspace("/invitemanager", orgData)}
            >
              Invitations
            </NavBarButton>
          </Collapsible>
          <Collapsible
            title={"Modèles"}
            defaultOpen={
              location.pathname.includes("/email") ||
              location.pathname.includes("/tags") ||
              location.pathname.includes("/packs") ||
              location.pathname.includes("/documents")
            }
          >
            <NavBarButton
              isActualPage={location.pathname.includes("/email")}
              visible={hasBasic(orgData) || !workspaceData}
              icon="nouveau-message"
              onClick={() => navigateWorkspace("/email", orgData)}
            >
              Modèles emails
            </NavBarButton>
            <NavBarButton
              isActualPage={location.pathname.includes("/tags")}
              icon="tag"
              onClick={() => navigateWorkspace("/tags", orgData)}
            >
              Tags
            </NavBarButton>{" "}
            <NavBarButton
              icon="cloche"
              visible={hasBasic(orgData) && !workspaceData}
              isActualPage={location.pathname.includes("/reminders")}
              onClick={() => navigateWorkspace("/reminders", orgData)}
            >
              Rappels
            </NavBarButton>
            <NavBarButton
              icon="pack"
              visible={hasBasic(orgData) && !workspaceData}
              onClick={() => navigateWorkspace("/packs", orgData)}
              isActualPage={location.pathname.includes("/packs")}
            >
              Prestations
            </NavBarButton>
            <NavBarButton
              icon="document"
              visible={hasBasic(orgData) && !workspaceData}
              onClick={() => navigateWorkspace("/documents", orgData)}
              isActualPage={location.pathname.includes("/documents")}
            >
              Documents
            </NavBarButton>{" "}
            <NavBarButton
              icon="bookshelf"
              isActualPage={location.pathname.includes("/bookshelf")}
              onClick={() => navigateWorkspace("/bookshelf", orgData)}
            >
              Bibliothèque
            </NavBarButton>
          </Collapsible>
          <Collapsible
            visible={hasBasic(orgData) && !workspaceData}
            title={"Intégrations"}
            defaultOpen={
              location.pathname.includes("/infiltrea") ||
              location.pathname.includes("/rtb") ||
              location.pathname.includes("/pennylane") ||
              location.pathname.includes("/stripe") ||
              location.pathname.includes("/bridge") ||
              location.pathname.includes("/cil") ||
              location.pathname.includes("/widget") ||
              location.pathname.includes("/agenda")
            }
          >
            <NavBarButton
              icon="rtb"
              visible={hasInfiltro(orgData)}
              isActualPage={location.pathname.includes("/rtb")}
              onClick={() => navigateWorkspace("/rtb", orgData)}
            >
              RT Batiment
            </NavBarButton>
            <NavBarButton
              icon="pennylane"
              visible={hasBasic(orgData)}
              isActualPage={location.pathname.includes("/pennylane")}
              onClick={() => navigateWorkspace("/pennylane", orgData)}
            >
              Pennylane
            </NavBarButton>
            <NavBarButton
              icon="google-calendar"
              visible={hasBasic(orgData)}
              isActualPage={location.pathname.includes("/agenda")}
              onClick={() => navigateWorkspace("/agenda", orgData)}
            >
              Agenda
            </NavBarButton>
            <NavBarButton
              icon="stripe"
              visible={false}
              isActualPage={location.pathname.includes("/stripe")}
              onClick={() => navigateWorkspace("/stripe", orgData)}
            >
              Stripe
            </NavBarButton>
            <NavBarButton
              icon="bridge"
              visible={hasBasic(orgData)}
              isActualPage={location.pathname.includes("/bridge")}
              onClick={() => navigateWorkspace("/bridge", orgData)}
            >
              Bridge Paiements
            </NavBarButton>
            <NavBarButton
              icon="hexagone-logement"
              visible={hasBasic(orgData)}
              isActualPage={location.pathname.includes("/cil")}
              onClick={() => navigateWorkspace("/cil", orgData)}
            >
              Carnets Logement
            </NavBarButton>
          </Collapsible>

          <Collapsible
            title={"Devis"}
            visible={hasBasic(orgData) && !workspaceData}
            defaultOpen={
              location.pathname.includes("/devisparams") ||
              location.pathname.includes("/products") ||
              location.pathname.includes("/formparams")
            }
          >
            <NavBarButton
              icon="devis"
              visible={hasBasic(orgData)}
              isActualPage={location.pathname.includes("/devisparams")}
              onClick={() => navigateWorkspace("/devisparams", orgData)}
            >
              Devis
            </NavBarButton>
            <NavBarButton
              icon="products"
              visible={hasBasic(orgData)}
              onClick={() => navigateWorkspace("/products", orgData)}
              isActualPage={location.pathname.includes("/products")}
            >
              Articles
            </NavBarButton>
            <NavBarButton
              icon="iframe"
              visible={hasBasic(orgData)}
              isActualPage={location.pathname.includes("/widget")}
              onClick={() => navigateWorkspace("/widget", orgData)}
            >
              Widget
            </NavBarButton>
            {false && (
              <NavBarButton
                icon="control"
                visible={hasBasic(orgData)}
                isActualPage={location.pathname.includes("/formparams")}
                onClick={() => navigateWorkspace("/formparams", orgData)}
              >
                Formulaires
              </NavBarButton>
            )}
          </Collapsible>
          <Collapsible
            title={"Premium"}
            visible={hasBasic(orgData) && !isOnlyBasic(orgData)}
            defaultOpen={
              location.pathname.includes("/mobileapp") ||
              location.pathname.includes("/controlparams") ||
              location.pathname.includes("/gallery") ||
              location.pathname.includes("/rdvparams")
            }
          >
            <NavBarButton
              icon="smartphone"
              visible={hasBasic(orgData)}
              onClick={() => navigateWorkspace("/mobileapp", orgData)}
              isActualPage={location.pathname.includes("/mobileapp")}
            >
              Application
            </NavBarButton>
            <NavBarButton
              icon="mobile-control"
              visible={hasBasic(orgData)}
              isActualPage={location.pathname.includes("/controlparams")}
              onClick={() => navigateWorkspace("/controlparams", orgData)}
            >
              Contrôles
            </NavBarButton>
            <NavBarButton
              icon="image"
              visible={hasBasic(orgData)}
              isActualPage={location.pathname.includes("/gallery")}
              onClick={() => navigateWorkspace("/gallery", orgData)}
            >
              Galerie
            </NavBarButton>
            <NavBarButton
              icon="planning"
              visible={hasBasic(orgData)}
              isActualPage={location.pathname.includes("/rdvparams")}
              onClick={() => navigateWorkspace("/rdvparams", orgData)}
            >
              Prise de RDV
            </NavBarButton>
          </Collapsible>
          <Collapsible
            title={"Expert"}
            visible={hasExpert(orgData)}
            defaultOpen={location.pathname.includes("")}
          >
            <NavBarButton
              icon="brain"
              visible={hasExpert(orgData)}
              isActualPage={location.pathname.includes("/extraction-ia")}
              onClick={() => navigateWorkspace("/extraction-ia", orgData)}
            >
              Extraction IA
            </NavBarButton>
            <NavBarButton icon="excel" visible={hasExpert(orgData)}>
              Excel
            </NavBarButton>
          </Collapsible>
        </>
      )}
    </div>
  );
}

export default ParametersNavBar;

export const PremiumBar = () => {
  return (
    <div className="text-h3 flex items-center bg-indigo-50 border-l-2 border-indigo-500 px-2 py-0.5 rounded-md w-fit flex-row gap-3 text-indigo-500 font-medium">
      Premium
    </div>
  );
};

export const ForeverBar = () => {
  return (
    <div className="text-h3 flex items-center bg-purple-50 px-2 py-0.5 rounded-full w-fit flex-row gap-3 text-violet-500 font-medium">
      Abonnement à vie
    </div>
  );
};

export const EngagementBar = ({ engagement }) => {
  return (
    <div
      className={` text-neutral-500 bg-neutral-100 text-h3 flex items-center px-2 py-0.5 rounded-lg w-fit flex-row gap-3 font-medium`}
    >
      {engagement === "forever"
        ? "Abonnement à vie"
        : engagement === "year"
          ? "Annuel"
          : "Mensuel"}
    </div>
  );
};

export const BusinessBar = () => {
  return (
    <div className="text-h3 flex items-center bg-sky-50 pr-2  border-l-2 border-blue-500 py-0.5 rounded-md w-fit flex-row gap-3  font-medium text-blue-600">
      <Icon1
        icon_name="hexagone2"
        fill="#2563eb  "
        size={18}
        margin="2px"
      ></Icon1>{" "}
      Business
    </div>
  );
};

export const StarterBar = () => {
  let dict = {
    infos_devis: {
      id: "Q0uDXceZZd2fO5vEUU8a9T",
      name: "Denys Loiret",
      email: "denys@ouestenergiecontrole.fr",
      phone: "06551511511",
      address: "1 RUE RAYMOND CIVET",
      postal: "44119",
      city: "TREILLIERES",
      country: "France",
    },
    infos_master: {
      name: "OUEST ENERGIE CONTROLE",
      email: "rapport@ouestenergiecontrole.fr",
      phone: "06510024621",
      date: "24/02/2025 20:29:03",
      logo: "https://storage.googleapis.com/foundry-2dlu01.appspot.com/logos/wmLGIwRMtQD2LLc6nXQf/OEC_LOGO.png",
    },
    form_name: "Descriptif du projet maison",
    caegories: [
      {
        name: "Catégorie Eau chaude sanitaire ",
        fields: [
          {
            name: "Ballon thermo",
            type: "check",
            value: false,
          },
          {
            name: "Lié au chauffage",
            type: "check",
            value: true,
          },
          {
            name: "Ballon solaire",
            type: "check",
            value: true,
          },
          {
            name: "Autre",
            type: "text",
            value: "truc chelou",
          },
          {
            name: "Modèle de l'équipement:",
            type: "text",
            value:
              "Dyson 3000 fdhdhshfh kjsdhjf hdsh fkhsdk dk dhks hds jhds hdskhsdkhkdkds fdd fd d dddfd",
          },
        ],
      },
      {
        name: "Catégorie Ventilation ",
        fields: [
          {
            name: "Simple flux hygro B",
            type: "check",
            value: true,
          },
          {
            name: "Double flux",
            type: "check",
            value: true,
          },
          {
            name: "Modèle de la vmc:",
            type: "text",
            value: "78DD PT",
          },
          {
            name: "Type de gaines",
            type: "text",
            value: "Souple renforcée",
          },
        ],
      },
    ],
  };
  return (
    <div className="text-h3 flex items-center bg-sky-100 pr-2 py-0.5 rounded-full w-fit flex-row gap-3  font-medium text-blue-600">
      <Icon1
        icon_name="hexagone2"
        fill="#2563eb  "
        size={18}
        margin="2px"
      ></Icon1>{" "}
      Starter
    </div>
  );
};
